import { type QueryOptions } from '@tanstack/query-core'

import { type CustomKeySettingEntity } from '@/libs/api'

import { fetchCustomKeySettings } from '../api'
import {
  type CustomKeySettingsSelectQueryParams,
  customKeySettingsQueryKeys
} from '../query-keys'

/**
 * 拠点のカスタムキー一覧取得 QueryOptions（#3463 VOC_PJ-829/851）。
 */
export const getCustomKeySettingsSelectQueryOptions = (
  params: CustomKeySettingsSelectQueryParams
): Required<
  Pick<QueryOptions<CustomKeySettingEntity[]>, 'queryKey' | 'queryFn'>
> => {
  return {
    queryKey: customKeySettingsQueryKeys.select(params),
    queryFn: async ({ signal }) => fetchCustomKeySettings(params, signal)
  }
}
